import { defineStore } from "pinia";

export const useExportStore = defineStore("export", {
    state: () => ({
        activeExportId: null,
        trackingToken: 0,
    }),
    actions: {
        startTracking(exportId) {
            this.activeExportId = exportId;
            this.trackingToken += 1;
        },
        stopTracking() {
            this.activeExportId = null;
        },
    },
});
